module.exports = __webpack_public_path__ + "img/energy-provider.ef04c96d.jpg";